import { certifications } from "../data/certifications";

const Certifications = () => {
  return (
    <section id="certifications" className="mb-12">
      <h2 className="text-3xl font-bold mb-4">Certifications</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {certifications.map((certification) => (
          <div
            key={certification}
            className="bg-white rounded-lg shadow p-4 text-center transition-all hover:shadow-lg"
          >
            <span className="text-gray-800">{certification}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Certifications;
